import React from 'react'
import sc, {Screenfull} from 'screenfull'

// based on packages/powtoon-html-player/src/components/FullscreenToggle.js

const screenfull: Screenfull = sc as Screenfull

interface FullScreenToggleResponse {
  isEnabled: () => boolean,
  isFullScreen: (boolean),
  toggleFullscreen: () => void
}

function useFullScreenToggle(
  ref: React.MutableRefObject<HTMLElement | undefined | null>,
  forceAllowFullscreen: boolean = false, additionalDependencies = []
): FullScreenToggleResponse {
  const [isFullScreen, setIsFullScreen] = React.useState<boolean>(false)

  const isEnabled = React.useCallback(
    () => forceAllowFullscreen || screenfull.isEnabled,
    [forceAllowFullscreen]
  )
  const toggleFullscreen = React.useCallback(() => {
    if (ref.current) {
      screenfull.toggle(ref.current)
    }
  }, [ref])
  const onFullScreenChange = React.useCallback(() => {
    setIsFullScreen(screenfull.isFullscreen)
  }, [])

  React.useEffect(
    () => {
      if (screenfull.isEnabled) {
        screenfull.on('change', onFullScreenChange)
      }
      return () => {
        if (screenfull.isEnabled) {
          screenfull.off('change', onFullScreenChange)
        }
      }
    },
    [ref, ...additionalDependencies]
  )
  return {
    isEnabled,
    isFullScreen,
    toggleFullscreen
  }
}

export default useFullScreenToggle